// extracted by css-extract-rspack-plugin
export default {"container":"RelationshipList-module__container__yKCtP"};